import axios from 'axios';
import { GET_CAC_AUTOCODE_SAMPLE_WEIGHTED, GET_CAC_AUTOCODE_SAMPLE_WEIGHTED_DATA,
  CLEAR_CAC_SAMPLE_WEIGHTED, UPDATE_CAC_SAMPLE_WEIGHTED, CAC_ADD_DEFAULT_BASE } from './actionTypes';
import * as urls from './urlTypes';

export function getSampleWeighted({
  sourceGrid,
  targetGrid,
  uid,
  accountId,
  productNo,
  weightType,
  divisor,
  expressionList,
  selectedNames,
  gridData,
  titlePrefix,
  originalNames,
  oldProductNo,
  weightChange,
}) {
  const url = `${urls.ROOT_URL}/crosstab/samplewgtd`;
  return dispatch => {
    axios({
      url,
      method: 'post',
      headers: {
        Accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
      validateStatus: status => status >= 200 && status < 202,
      data: {
        uid,
        accountId,
        productNo,
        weightType,
        divisor,
        expressionList,
      },
    })
      .then(response => {
        dispatch({
          type: GET_CAC_AUTOCODE_SAMPLE_WEIGHTED,
          payload: response.data.data,
          gridData,
          sourceGrid,
          targetGrid,
          selectedNames,
          expressionList,
          titlePrefix,
          originalNames,
          productNo,
          oldProductNo,
          weightChange,
        });
      })
      .catch(response => console.warn(response));
  };
}

export const getSampleWeightedData = ({
  sourceGrid,
  targetGrid,
  accountId,
  productNo,
  expressionList,
  selectedNames,
  gridData,
  titlePrefix,
  originalNames,
  response,
}) => ({
  type: GET_CAC_AUTOCODE_SAMPLE_WEIGHTED_DATA,
  payload: response,
  gridData,
  sourceGrid,
  targetGrid,
  selectedNames,
  expressionList,
  titlePrefix,
  originalNames,
  productNo,
  accountId,
});

export const clearSampleWeighted = targetGrid => ({
  type: CLEAR_CAC_SAMPLE_WEIGHTED,
  targetGrid,
});

export const updateSampleWeighted = (gridData, targetGrid) => ({
  type: UPDATE_CAC_SAMPLE_WEIGHTED,
  gridData,
  targetGrid,
});

export const addDefaultBase = () => ({
  type: CAC_ADD_DEFAULT_BASE,
});
